import { useEffect } from 'react';
import config from '../config';

const useParallaxScript = (
  hasParallaxBool: boolean,
  elementId: string,
  speed = config.backgroundImage.parallaxEffect,
) => {
  useEffect(() => {
    if (!hasParallaxBool) {
      const targetElement = document.getElementById(elementId);
      targetElement.style.backgroundPosition = 'center 0px';
      return () => {};
    }

    const script = document.createElement('script');
    script.setAttribute('keepexport', 'true');
    script.innerHTML = `
      (() => {
        const handleScroll = () => {
          const blocksContainer = document.getElementById('blocksContainer');
          const targetElement = document.getElementById('${elementId}');
          if (!blocksContainer || !targetElement) return;
          const parentElement = blocksContainer.parentNode instanceof HTMLElement ? blocksContainer.parentNode : null;
          if (!parentElement) return;
        
          const rect = targetElement.getBoundingClientRect();
          const isInViewport = rect.bottom >= 0 && rect.top <= window.innerHeight;
          // Check if the element is in the viewport.
          if (!isInViewport) return;          
        
          // Information necessary to check if the element is in the middle of the screen
          const windowHeight = window.innerHeight;
          const viewportMiddle = windowHeight / 2;
          const headerHeight = 100;
          // Added headerHeight to the targetElement height to calculate the middle of the element
          const elementMiddle = rect.top + ((rect.height-headerHeight) / 2);
        
          // Calculate backgroundImage position based on element position from the middle of the screen
          let position = 'top 50% right 50%';
          const percentageOffset = 50 + (((elementMiddle - viewportMiddle) / windowHeight) * 100);
          position = \`top \${percentageOffset}% right 50%\`;

          targetElement.style.backgroundPosition = \`\${position}\`;
        };
        
        const blocksContainer = document.getElementById('blocksContainer');
        if (blocksContainer && blocksContainer.parentNode instanceof HTMLElement) {
          const parentElement = blocksContainer.parentNode;
          parentElement.addEventListener('scroll', handleScroll, { passive: true });
        }

        
        handleScroll();
      })();`;

    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [elementId, hasParallaxBool]);
};

export default useParallaxScript;
